/* eslint-disable max-len */
import {pathWithParams, apiVersion, DEFAULT_TIMEOUT, setErrorApi} from '@/utils/constants';
import {handleErrorCustom} from '@/utils/errorHandling';
import {sucessCustom} from '@/utils/successHandling';
import {useAxios} from '@sttedra_ui/framework';

// #region Globals
const {base} = useAxios();
const servicio = 'Avisos';
// #endregion

// #region Public functionslist
async function postFilterAvisos(_datafilter) {
  const url = `${pathWithParams()}${servicio}/Filter?${apiVersion}`;
  try {
    const {data: response} = await base.post(url, _datafilter, {timeout: DEFAULT_TIMEOUT});
    return response.objetoSalida;
  } catch (error) {
    if (error.code === 'ERR_NETWORK') setErrorApi();
    handleErrorCustom(error);
  }
}

async function getAvisosId(_id) {
  if (!_id && _id == 0) {
    return;
  }
  try {
    const url = `${pathWithParams()}${servicio}/${_id}?${apiVersion}`;
    const {data: response} = await base.get(url, {timeout: DEFAULT_TIMEOUT});
    return response.objetoSalida;
  } catch (error) {
    if (error.code === 'ERR_NETWORK') setErrorApi();
    handleErrorCustom(error);
  }
}

async function postAddAvisos(_data) {
  const url = `${pathWithParams()}${servicio}?${apiVersion}`;
  try {
    const {data: response} = await base.post(url, _data, {timeout: DEFAULT_TIMEOUT});
    sucessCustom(response.message);
    return response.success;
  } catch (error) {
    if (error.code === 'ERR_NETWORK') setErrorApi();
    handleErrorCustom(error);
  }
}

async function getListAvisosActivos(_fechaActual) {
  const url = `${pathWithParams()}${servicio}/ListAvisosActivos?fechaActual=${_fechaActual}&${apiVersion}`;
  try {
    const {data: response} = await base.get(url, {timeout: DEFAULT_TIMEOUT});
    return response.objetoSalida;
  } catch (error) {
    if (error.code === 'ERR_NETWORK') setErrorApi();
    handleErrorCustom(error);
  }
}

async function getCalcularFechaAlarma(_unidadId, _fechaAviso, _tipoDiasAlarmaId, _diasAlarma, _mesesAlarma) {
  let urlFecha = '';
  if (_unidadId) {
    urlFecha += `unidadId=${_unidadId}&`;
  }
  if (_fechaAviso) {
    urlFecha += `FechaAviso=${_fechaAviso}&`;
  }
  if (_tipoDiasAlarmaId) {
    urlFecha += `TipoDiasAlarmaId=${_tipoDiasAlarmaId}&`;
  }
  if (_diasAlarma) {
    urlFecha += `DiasAlarma=${_diasAlarma}&`;
  }
  if (_mesesAlarma) {
    urlFecha += `MesesAlarma=${_mesesAlarma}&`;
  }

  const url = `${pathWithParams()}${servicio}/CalcularFechaAlarma?${urlFecha}${apiVersion}`;
  try {
    const {data: response} = await base.get(url, {timeout: DEFAULT_TIMEOUT});
    return response.objetoSalida;
  } catch (error) {
    if (error.code === 'ERR_NETWORK') setErrorApi();
    handleErrorCustom(error);
  }
}

export {
  postFilterAvisos,
  getAvisosId,
  postAddAvisos,
  getListAvisosActivos,
  getCalcularFechaAlarma,
};
